export default __webpack_public_path__ + "static/media/blog-diet-banner.c6176be3.jpg";